import { useState } from "react";
import axios from "axios";
import BASE from "../config";

const useGetFile = (token) => {
  const [imageLoad, setImageLoad] = useState(false);
  const getImage = async (path) => {

    if(!path) return

    const config = {
      url: BASE.api + `/aws/awsFile`,
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      data: {
        path: path
      }
    };
    try {
      setImageLoad(true);
      const result = await axios(config);
      setImageLoad(false);
      return result.data;
    } catch (err) {
      setImageLoad(false);
      console.log(err);
    }
  };

  return { imageLoad, getImage };
};

export default useGetFile;
